import { Card } from 'react-bootstrap'

function FinCard(props)
{
    return (
        <div>
            <Card border="dark" style={{ width: '18rem' }} bg={props.Clr} className="mb-2" >
            <Card.Header as="h2">{props.Title}</Card.Header>
            <Card.Body>
                <Card.Title>{props.Text}</Card.Title>
            </Card.Body>
            </Card>
        </div>
    );
}

export default FinCard;